module.exports = __webpack_public_path__ + "img/article4-6.971faf75.png";